export default function formatCountLabel(count, singular, plural = `${singular}s`) {
  const normalizedCount = Number(count) || 0;
  return `${normalizedCount} ${normalizedCount === 1 ? singular : plural}`;
}
